import React from 'react';
import dollars from '../../dollar-format';

function integer(value) {
	if (value === undefined || value === null || value === '') return '';
	return Math.round(Number(value)).toLocaleString();
}

function percent(value) {
	if (value === undefined || value === null || value === '') return '';
	return Number(value).toFixed(2)+'%';
}

function roundedDollars(value){
	return dollars(Math.round(value))
}

function decimalsDollars(value){
	return dollars(value,true);
}

const ListStats = (props) => {
	const { stats, query } = props;
    const isHSC = query.source === 'HSC';
    const isClosed = query.close_of_escrow_min || query.close_of_escrow_max || query.status === 'Closed' || query.hsc_status === 'Closed';

	// check if filtered status is exclusively 'In Negotiation', 'Under Contract', or a combination of the two
	let isNegotiation = false;
	if (query.status) {
		const status = query.status.split(',');
		let count = 0;
		if (status.indexOf('In Negotiation') !== -1) {
			count++;
		}
		if (status.indexOf('Under Contract') !== -1) {
			count++;
		}
		if (count && count === status.length) {
			isNegotiation = true;
		}
	}

	let columns = [
		{
			key: 'no-key',
			label: '# of Properties',
			format: function() {
				try {
					return Number(stats.count).toLocaleString();
				} catch (err) {
					return '';
				}
			},
		},
		{
			key: 'total-price',
			label: 'Total Price',
			format: function() {
				let key;

				if (isNegotiation) {
					key = 'total_negotiation_price';
				} else if (isClosed) {
					key = 'total_sold_price';
				} else if (isHSC) {
                    key = 'total_hsc_price';
                } else {
					key = 'total_list_price';
				}

				return dollars(stats[key]);
			},
		},
		{
			key: 'total_sqft',
			label: 'Total SQ FT',
			format: integer,
		},
	];

	if (isHSC) {
        columns.push({
            key: 'total_loan_amount',
            label: 'Total Loan Volume',
            format: dollars,
        }, {
        	key: 'loan_amount',
			label: 'Loan Amount - Ave',
			format: roundedDollars
		}, {
        	key: 'ltv',
			label: 'LTV – Ave',
			format: percent,
		}, {
        	key: 'interest_rate',
			label: 'Rate – Ave',
			format: percent,
		}, {
        	key: 'lenders',
			label: '# of Lenders',
			format: integer,
        });
	} else {
        if (isClosed) {
            columns.push({
                key: 'sold_price',
                label: 'Price at Close – Ave',
                format: roundedDollars
            }, {
                key: 'close_cap_rate',
                label: 'Cap Rate at Close – Ave',
                format: percent,
            }, {
                key: 'net_operating_income',
                label: 'NOI – Ave',
                format: roundedDollars
            });
        }

        columns.push({
			key: 'list_price',
			label: 'List Price – Ave',
			format: roundedDollars
		}, {
        	key: 'capitalization_rate',
			label: 'List Cap Rate – Ave',
			format: percent,
		});

        if (!isClosed) {
            columns.push({
                key: 'net_operating_income',
                label: 'NOI – Ave',
                format: roundedDollars
            })
        }

        if (isNegotiation) {
            columns.push({
                key: 'negotiation_price',
                label: 'Neg. Price – Ave',
                format: roundedDollars
			}, {
                key: 'negotiation_cap_rate',
                label: 'Neg. Cap Rate – Ave',
                format: percent,
            })
        }

        if (isClosed) {
            columns.push({
                key: 'close_price_per_sqft',
                label: 'Close PSF – Ave',
				format: decimalsDollars
            })
        } else if (isNegotiation) {
            columns.push({
                key: 'negotiation_price_per_sqft',
                label: 'Neg. PSF – Ave',
				format: decimalsDollars
            });
        } else {
            columns.push({
                key: 'price_per_sqft',
                label: 'PSF – Ave',
				format: decimalsDollars
            });
        }

        columns.push({
            key: 'rent_per_sqft',
            label: 'Rent / SQ FT – Ave',
			format: decimalsDollars
        });

        columns.push({
            key: 'sqft',
            label: 'SQ FT – Ave',
            format: integer,
        }, {
            key: 'vacancy',
            label: 'Occupancy – Ave',
            format: percent,
        });
    }

	return stats ? (
		<div className='ListStats'>
			{
				columns.map(col => (
					<div className='ListStats_li' key={col.key}>
						<span className='ListStats_li_avg'>{col.key === 'LENDERS' ? props.uniquePropCount : col.format(stats[col.key])}</span>
						<span className='ListStats_li_name'>{col.label}</span>
					</div>
				))
			}
		</div>
	) : null
};

export default ListStats;
